import React from "react";
import { Link } from "react-router-dom";
import Blog_1 from "../../../assets/images/blog-news/01.png";
import Blog_2 from "../../../assets/images/blog-news/02.png";
import Blog_3 from "../../../assets/images/blog-news/03.png";

const blogPosts = [
    {
        id: 1,
        date: "24",
        month: "Nov",
        img: Blog_1,
        subTitle: "Premium wooden sofa",
        title: "Updating your Bedroom For Exclusive Furniture.",
        link: "/BlogDetails",
    },
    {
        id: 2,
        date: "25",
        month: "Nov",
        img: Blog_2,
        subTitle: "Premium wooden sofa",
        title: "Explore Our Latest Wooden Table Furniture",
        link: "/BlogDetails",
    },
    {
        id: 3,
        date: "26",
        month: "Nov",
        img: Blog_3,
        subTitle: "Premium wooden sofa",
        title: "Glorious Table Lamps For your modern Room.",
        link: "/BlogDetails",
    },
];

const Blog = () => {
    return (
        <section id="blog-news" className="blog-news-main-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section text-center">
                            <h2 className="section-heading-four">Latest Blog &amp; News</h2>
                        </div>
                    </div>
                    {blogPosts.map((post) => (
                        <div key={post.id} className="col-lg-4 col-md-4">
                            <div className="blog-block">
                                <div className="blog-news-img">
                                    <span className="date">{post.date}</span>
                                    <span className="month">{post.month}</span>
                                    <Link to={post.link} className="sale" title="">
                                        <img src={post.img} className="img-fluid" alt={post.title} />
                                    </Link>
                                </div>
                                <div className="blog-news-dtls">
                                    <h6 className="blog-sub-title">{post.subTitle}</h6>
                                    <h4 className="blog-title">
                                        <Link to={post.link} title="">{post.title}</Link>
                                    </h4>
                                    <Link to={post.link} className="btn btn-info" title="">
                                        Learn More <i className="flaticon-right-arrow" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Blog;
